import store from '../redux/store.js';
import * as session from './session.js';


/**
 * Record normal event
 * @param type
 * @param id
 * @param meta
 */
async function record(type, id = null) {
    if (!session.getToken()) {
        return false;
    }

    const isDependent = await session.isDependent();

    if (store.getState().user.meta && !id) {
        if (isDependent) {
            id = { dependentID: store.getState().user.meta.dependentID };
        } else {
            id = { userID: store.getState().user.meta.userID };
        }
    }

    if (!id) {
        return false;
    }


    return true;
}

export {
    record
};